// extracted by mini-css-extract-plugin
module.exports = {"container":"TopAmenities_container__11Ubr","title":"TopAmenities_title__pt_3S"};